import "./player.scss";
import "./SelectPlayer.scss";

function SelectPlayer({player, onSelected, isSelected}) {
    return (
        <div className="select-player-container">
                <p className="player-title">{player.name}</p>
                <input type="checkbox" id={player.id} onChange={() => onSelected(player)} checked={isSelected}></input>
        </div>
    )
}

export default SelectPlayer;